
import React, { useEffect, useState } from "react";
import { ApiUrl } from "../../config/apiConfig";
import { getData } from "../../services/Axios/Axios";

import { ActivityDocs } from "./UIElement/PermitCard";

import Swal from 'sweetalert2';

import { confirmAction } from '../../utils/utils';

import { putData } from '../../services/Axios/Axios';
import { Student, StudentMilestones } from '../../types/types';
import DotCard from "./DotCard";


interface Prop {
  student: Student;
  setStudent: React.Dispatch<React.SetStateAction<Student>>;
  scheduleMeeting: () => Promise<void>;
  onCustomerUpdateSuccess?: () => Promise<void>; // optional
  customerId: string;
  selectedCustomer?: any | null;
}

export default function CustomerActivity({
  student,
  setStudent,
  scheduleMeeting,
  onCustomerUpdateSuccess = async () => { },
  customerId,
}: any) {

  type DocumentItem = {
    id: number;
    title: string;
    date?: string;

  };
  // defined file states in parent to open the file first on clicking add permit
  const [file, setFile] = useState<File | null>(null);
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [fileType, setFileType] = useState<string | null>(null);
  const [isPermitModalOpen, setIsPermitModalOpen] = useState(false);
  const [allPermits, setAllPermits] = useState<ActivityDocs[]>([]);
  const [selectedPermit, setSelectedPermit] = useState<ActivityDocs | null>(
    null
  );
  const documents: DocumentItem[] = [
    { id: 1, title: "CLASS 1", date: "24 Feb 2026, 05:30 AM" },
    { id: 2, title: "CLASS 2", date: "25 Feb 2026, 05:30 AM" },
    { id: 3, title: "CLASS 3", date: "26 Feb 2026, 05:30 AM" },

  ];
  const [isTmsUser, setIsTmsUser] = useState(false);
  const [isDOT, setIsDOT] = useState(false);
  const [isJobPrep, setIsJobPrep] = useState(false);
  // added file states handling logic in add permit
  function handleAddPermit() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/pdf,image/*";
    input.onchange = (e: any) => {
      const selected = e.target.files?.[0];
      if (!selected) return;
      const previewUrl = URL.createObjectURL(selected);
      setFile(selected);
      setFileType(selected.type);
      setFilePreview(previewUrl);
      setIsPermitModalOpen(true); // only open modal after file selected
    };
    setSelectedPermit(null);
    input.click();
  }

  const OPTIONS = [
    { key: "study", label: "Study" },
    { key: "practice", label: "Practice" },
    { key: "test", label: "Test" },
    { key: "review", label: "Review" },
    { key: "certificate", label: "Certificate" },
  ];
  const getAllActivities = async () => {
    const data = await getData(`${ApiUrl.getAllActivities}${customerId}`);
    setAllPermits(data.data);
  };

  useEffect(() => {
    getAllActivities();
  }, [customerId]);

  const toggleCompliance = (
    currentValue: boolean,
    setValue: React.Dispatch<React.SetStateAction<boolean>>,
    label: string,
  ) => {
    Swal.fire({
      title: `Change ${label} Compliance?`,
      html: `Are you sure you want to mark ${label} as ${currentValue ? "INCOMPLETE" : "COMPLETE"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then((result) => {
     
      if (result.isConfirmed) {
        setValue(!currentValue);
        handleClick("isDotCompliant")
      }
    });
  };

 

  const handleClick = async (key: keyof StudentMilestones | string) => {
    const isMilestone = key in (student.milestones || {});
    const currentValue = isMilestone
      ? student.milestones?.[key as keyof StudentMilestones]
      : student[key as keyof Student];
    const LABELS: Record<string, string> = {
      isDotCompliant: "DOT",
    };
    const readableKey = LABELS[key] || key;
    console.log(readableKey);
    if (key === "isDotCompliant" && currentValue === true) {
      Swal.fire({
        title: "Action Not Allowed",
        html: `DOT compliance cannot be changed.`,
        icon: "warning",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title-text",
          htmlContainer: "swal-body-text",
          confirmButton: "swal-confirm-buttond",
        },
        buttonsStyling: false,
      });
      return;
    }
    confirmAction(`Do you want to mark ${readableKey} as ${currentValue ? "imcomplete" : "complete"
      }?`, async () => {
        try {
          let updatedStudent = { ...student };
          let payload = {};

          if (isMilestone) {
            updatedStudent = {
              ...student,
              milestones: {
                ...student.milestones!,
                [key]: !currentValue,
              },
            };
            payload = { milestones: updatedStudent.milestones };
          } else {
            updatedStudent = {
              ...student,
              [key]: !currentValue,
            };
            payload = { [key]: updatedStudent[key as keyof Student] };
          }

          await putData(`${ApiUrl.updateStudent}${student._id}`, payload);
          setStudent(updatedStudent);
          // onCustomerUpdateSuccess();
        } catch (error) {
          console.log(error);
        }
      })

  };
  const handleUpload = (id: number) => {
    console.log("Upload clicked for document id:", id);
  };

  return (

    <div className="flex flex-col h-[calc(86.5vh-200px)] 2xl:h-[calc(88vh-200px)] 4xl:h-[calc(92vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">
      <div className="w-full">
        <div className="w-full">
          <div className="sm:grid sm:grid-cols-2 sm:gap-2 lg:gap-0 lg:flex lg:items-center lg:justify-between mb-4 pb-4 border-b border-gray-200"> 

            <div className='flex items-center gap-3'>
              <h1 className=" text-[13px]">
                TMS Users
              </h1>
              <div>
                <label
                  className={`radio-button-container flex items-center justify-center w-full h-8 
             ${isTmsUser
                      ? "!bg-green-100 !border-greenBg text-greenBg"
                      : "!bg-red-100 !border-red-500 text-red-500"

                    }
            
          `}
                >
                  <input
                    type="checkbox"
                    checked={isTmsUser}
                    onChange={() =>
                      toggleCompliance(
                        isTmsUser,
                        setIsTmsUser,
                        "TMS User",
                      )
                    }
                    className="hidden"

                  />
                  <span
                    className={
                      isTmsUser ? "checkmark" : "checkmark-no"
                    }
                  ></span>
                  {isTmsUser ? "Completed" : "Pending"}
                </label>
              </div>
            </div>
            <div className='flex items-center gap-3'>
              <h1 className=" text-[13px]">
                DOT Compliance
              </h1>
              <div>
                <label
                  className={`radio-button-container flex items-center justify-center w-full h-8 
         ${isDOT ? "!bg-green-100 !border-greenBg text-greenBg" : "!bg-red-100 !border-red-500 text-red-500"}
         
        `}
                >
                  <input
                    type="checkbox"
                    checked={isDOT}
                    onChange={() =>{
                      toggleCompliance(
                        isDOT,
                        setIsDOT,
                        "DOT Compliance",

                      )}
                    }
                    className="hidden"

                  />
                  <span
                    className={
                      isDOT ? "checkmark" : "checkmark-no"
                    }
                  ></span>
                  {isDOT ? "Completed" : "Pending"}
                </label>
              </div>
            </div>
           <div className='flex items-center sm:gap-6 lg:gap-3'>
              <h1 className=" text-[13px]">
                Job Prep
              </h1>
              <div>
                <label
                  className={`radio-button-container flex items-center justify-center w-full h-8 
           ${isJobPrep ? "!bg-green-100 !border-greenBg text-greenBg" : "!bg-red-100 !border-red-500 text-red-500"}
         
        `}
                >
                  <input
                    type="checkbox"
                    checked={isJobPrep}
                    onChange={() =>
                      toggleCompliance(
                        isJobPrep,
                        setIsJobPrep,
                        "Job Prep",

                      )
                    }
                    className="hidden"

                  />
                  <span
                    className={
                      isJobPrep ? "checkmark" : "checkmark-no"
                    }
                  ></span>
                  {isJobPrep ? "Completed" : "Pending"}
                </label>
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-wrap gap-4">
              {documents.map((doc) => (
                <DotCard
                  key={doc.id}
                  item={doc}
                  onUpload={handleUpload}
                />
              ))}
            </div>
          </div>
       
      <div className="w-full pt-2 border-t border-gray-200 mt-4 sm:grid sm:grid-cols-2 lg:flex ">
            <h3 className="font-normal text-[14px] mb-1  text-[#323232] mr-2 ">Reports</h3>
            <div className='bg-white    mx-4 mb-4  rounded-md  h-fit sm:grid sm:grid-cols-2 lg:flex lg:items-center gap-5'>
              {OPTIONS.map((opt) => (
                <div className="" key={opt.key}>
                  <h1 className="text-[11px] font-regular text-gray-400">
                    {opt.label}
                  </h1>
                  <label className="radio-button-container sm:w-[6rem] lg:w-full h-8"> Pending
                    <input
                      type="checkbox"
                      checked={
                        student?.milestones?.[
                        opt.key as keyof StudentMilestones
                        ] || false
                      }
                      onChange={() =>
                        handleClick(
                          opt.key as keyof StudentMilestones
                        )
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              ))}
            </div>
          </div>


        </div>

</div>
      </div>
    </div>
  );
}
